import React, { ReactElement } from "react";
import { Table } from "antd";
import { FulfillmentCompletionsByUserRecord } from "../../../../redux/types/reportTypes";

export const columns = [
  {
    title: "User",
    dataIndex: "user",
    fixed: true,
    width: 300,
  },
  {
    title: "Association",
    dataIndex: "association",
  },
  {
    title: "Association Errors",
    dataIndex: "associationErrors",
  },
  {
    title: "Association check",
    dataIndex: "associationCheck",
  },
  {
    title: "Check Errors",
    dataIndex: "checkErrors",
  },
  {
    title: "Resolution",
    dataIndex: "resolution",
  },
  {
    title: "Biz Basics",
    dataIndex: "bizBasic",
  },
  {
    title: "Biz Advanced",
    dataIndex: "bizAdvance",
  },
  {
    title: "Biz Logo",
    dataIndex: "bizLogo",
  },
  {
    title: "Website Entry",
    dataIndex: "websiteEntry",
  },
  {
    title: "Ad Design",
    dataIndex: "adDesign",
  },
  {
    title: "Design Review",
    dataIndex: "designReview",
  },
  {
    title: "Basics Review",
    dataIndex: "basicReview",
  },
  {
    title: "Advanced Review",
    dataIndex: "advanceReview",
  },
  {
    title: "Duplicate Review",
    dataIndex: "duplicateReview",
  },
  {
    title: "Offer Count",
    dataIndex: "offerCount",
  },
  {
    title: "Offer Count Resolution",
    dataIndex: "offerCountResolution",
  },
];

type UserTableProps = {
  loading: boolean;
  records: Array<FulfillmentCompletionsByUserRecord>;
};

const UserTable = ({ loading, records }: UserTableProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="user"
    pagination={false}
    scroll={{ y: 250, x: 3200 }}
  />
);

export default UserTable;
